module.exports = __webpack_public_path__ + "static/media/2.48dc0fa3.svg";